/**
 * @(#)2020/03/16.
 * YxUpload，用于上传数据 -aws逻辑
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import BaseUpload from "../BaseUpload";
import { ossValueFromHandle } from "../tools";
import { YxComponent } from "../../../YxComponent";
import { get, random, merge, toArray } from "../../../../utils";
import UploadHuawei from "../Upload-huawei";
import UploadFileAws from "../../../../utils/upload/uploadFileAws";

/**
 * 亚马逊上传
 *
 * @class UploadAws
 * @extends {YxComponent}
 */
class UploadAws extends UploadHuawei {
  constructor(props, context) {
    super(props, context);
    this.uploadFile = get(
      this.props,
      "uploadFile",
      new UploadFileAws(this.props)
    );
    this.id = random();
  }

  render() {
    return <BaseUpload {...this.param} />;
  }
}

export default UploadAws;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Upload-Aws/index.js